/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AgentConfigsService {
  /** @summary List */
  listAgentConfigs: {
    /** @summary List */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListAgentConfigsParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListAgentConfigsSchema,
        options: {
          parameters: ListAgentConfigsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListAgentConfigsData, ListAgentConfigsError>>
    ): Promise<RequestFnResponse<ListAgentConfigsData, ListAgentConfigsError>>;
    /** @summary List */
    getQueryKey(
      parameters: DeepReadonly<ListAgentConfigsParameters> | void
    ): ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentConfigsService.listAgentConfigs.useQuery()
     * ```
     */
    useQuery<TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          TData,
          ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentConfigsService.listAgentConfigs.useQuery()
     * ```
     */
    useQuery<TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          TData,
          ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /** @summary List */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListAgentConfigsParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentConfigsService.listAgentConfigs.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAgentConfigsParameters,
      TQueryFnData = ListAgentConfigsData,
      TData = OperationInfiniteData<TQueryFnData, ListAgentConfigsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAgentConfigsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentConfigsService.listAgentConfigs.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAgentConfigsParameters,
      TQueryFnData = ListAgentConfigsData,
      TData = OperationInfiniteData<TQueryFnData, ListAgentConfigsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAgentConfigsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAgentConfigsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listAgentConfigsTotal = qraft.agentConfigsService.listAgentConfigs.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listAgentConfigsResults = qraft.agentConfigsService.listAgentConfigs.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listAgentConfigsCombinedResults = qraft.agentConfigsService.listAgentConfigs.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListAgentConfigsSchema,
          ListAgentConfigsParameters,
          ListAgentConfigsData,
          ListAgentConfigsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListAgentConfigsData, ListAgentConfigsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListAgentConfigsData, ListAgentConfigsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentConfigsService.listAgentConfigs.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          TData,
          ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentConfigsService.listAgentConfigs.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListAgentConfigsParameters, TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          OperationInfiniteData<TData, ListAgentConfigsParameters>,
          ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAgentConfigsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListAgentConfigsParameters>,
      OperationError<ListAgentConfigsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listAgentConfigsData = qraft.agentConfigsService.listAgentConfigs.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listAgentConfigsCombinedData = qraft.agentConfigsService.listAgentConfigs.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListAgentConfigsSchema,
          ListAgentConfigsParameters,
          ListAgentConfigsData,
          ListAgentConfigsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListAgentConfigsData, ListAgentConfigsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListAgentConfigsData, ListAgentConfigsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      > | void
    ): Promise<ListAgentConfigsData>;
    /** @summary List */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      > | void
    ): Promise<ListAgentConfigsData>;
    /** @summary List */
    fetchInfiniteQuery<TPageParam extends ListAgentConfigsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        DeepReadonly<TPageParam>,
        ListAgentConfigsError
      > | void
    ): Promise<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>>;
    /** @summary List */
    prefetchInfiniteQuery<TPageParam extends ListAgentConfigsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        DeepReadonly<TPageParam>,
        ListAgentConfigsError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureInfiniteQueryData<TPageParam extends ListAgentConfigsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        DeepReadonly<TPageParam>,
        ListAgentConfigsError
      > | void
    ): Promise<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>>;
    /** @summary List */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void)
    ): ListAgentConfigsData | undefined;
    /** @summary List */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void)
    ): OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters> | undefined;
    /** @summary List */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
            data: NoInfer<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
            data: ListAgentConfigsData | undefined,
          ]
        >;
    /** @summary List */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void)
    ): QueryState<ListAgentConfigsData, ListAgentConfigsError> | undefined;
    /** @summary List */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListAgentConfigsParameters>
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>, ListAgentConfigsError>
      | undefined;
    /** @summary List */
    setQueryData(
      parameters:
        | (DeepReadonly<ListAgentConfigsParameters> | undefined)
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
      updater: Updater<
        NoInfer<ListAgentConfigsData> | undefined,
        NoInfer<DeepReadonly<ListAgentConfigsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListAgentConfigsData | undefined;
    /** @summary List */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListAgentConfigsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters> | undefined;
    /** @summary List */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      updater: Updater<NoInfer<ListAgentConfigsData> | undefined, NoInfer<ListAgentConfigsData> | undefined>,
      options?: SetDataOptions
    ): Array<ListAgentConfigsData | undefined>;
    /** @summary List */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        TInfinite,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): void;
    /** @summary List */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): number;
    schema: ListAgentConfigsSchema;
    types: {
      parameters: ListAgentConfigsParameters;
      data: ListAgentConfigsData;
      error: ListAgentConfigsError;
    };
  };
  /** @summary Create */
  createAgentConfig: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateAgentConfigBody, CreateAgentConfigParameters, TMeta, TSignal>,
      client?: (
        schema: CreateAgentConfigSchema,
        options: ServiceOperationMutationFnOptions<CreateAgentConfigBody, CreateAgentConfigParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateAgentConfigData, CreateAgentConfigError>>
    ): Promise<RequestFnResponse<CreateAgentConfigData, CreateAgentConfigError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateAgentConfigParameters> | void
    ): ServiceOperationMutationKey<CreateAgentConfigSchema, CreateAgentConfigParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.createAgentConfig.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.createAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateAgentConfigBody, TContext = unknown>(
      parameters: DeepReadonly<CreateAgentConfigParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateAgentConfigSchema,
        CreateAgentConfigData,
        CreateAgentConfigParameters,
        TVariables,
        OperationError<CreateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<CreateAgentConfigData, OperationError<CreateAgentConfigError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.createAgentConfig.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.createAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateAgentConfigSchema,
        CreateAgentConfigData,
        CreateAgentConfigParameters,
        TVariables,
        OperationError<CreateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<CreateAgentConfigData, OperationError<CreateAgentConfigError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createAgentConfigTotal = qraft.agentConfigsService.createAgentConfig.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createAgentConfigTotal = qraft.agentConfigsService.createAgentConfig.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateAgentConfigSchema,
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createAgentConfigPendingMutationVariables = qraft.agentConfigsService.createAgentConfig.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createAgentConfigMutationData = qraft.agentConfigsService.createAgentConfig.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateAgentConfigData,
        OperationError<CreateAgentConfigError>,
        MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateAgentConfigSchema,
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateAgentConfigData,
          OperationError<CreateAgentConfigError>,
          MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateAgentConfigSchema,
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentConfigsService.createAgentConfig.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentConfigsService.createAgentConfig.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateAgentConfigSchema,
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
      ):
        | Mutation<
            CreateAgentConfigData,
            CreateAgentConfigError,
            MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateAgentConfigSchema,
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateAgentConfigData,
          CreateAgentConfigError,
          MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
          TContext
        >
      >;
    };
    schema: CreateAgentConfigSchema;
    types: {
      parameters: CreateAgentConfigParameters;
      data: CreateAgentConfigData;
      error: CreateAgentConfigError;
      body: CreateAgentConfigBody;
    };
  };
  /** @summary Get */
  getAgentConfig: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAgentConfigSchema, GetAgentConfigParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetAgentConfigParameters, TMeta, TSignal>,
      client?: (
        schema: GetAgentConfigSchema,
        options: {
          parameters: GetAgentConfigParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAgentConfigData, GetAgentConfigError>>
    ): Promise<RequestFnResponse<GetAgentConfigData, GetAgentConfigError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetAgentConfigParameters>
    ): ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentConfigsService.getAgentConfig.useQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          TData,
          ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentConfigsService.getAgentConfig.useQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          TData,
          ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAgentConfigError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAgentConfigParameters>
    ): ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentConfigsService.getAgentConfig.useInfiniteQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAgentConfigParameters,
      TQueryFnData = GetAgentConfigData,
      TData = OperationInfiniteData<TQueryFnData, GetAgentConfigParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAgentConfigError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentConfigsService.getAgentConfig.useInfiniteQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAgentConfigParameters,
      TQueryFnData = GetAgentConfigData,
      TData = OperationInfiniteData<TQueryFnData, GetAgentConfigParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAgentConfigError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAgentConfigData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAgentConfigTotal = qraft.agentConfigsService.getAgentConfig.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAgentConfigByParametersTotal = qraft.agentConfigsService.getAgentConfig.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             agent_config_id: agentConfigId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAgentConfigResults = qraft.agentConfigsService.getAgentConfig.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAgentConfigCombinedResults = qraft.agentConfigsService.getAgentConfig.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAgentConfigSchema,
          GetAgentConfigParameters,
          GetAgentConfigData,
          GetAgentConfigError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAgentConfigData, GetAgentConfigError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAgentConfigData, GetAgentConfigError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.agentConfigsService.getAgentConfig.useSuspenseQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          TData,
          ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentConfigsService.getAgentConfig.useSuspenseInfiniteQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAgentConfigParameters, TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          OperationInfiniteData<TData, GetAgentConfigParameters>,
          ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAgentConfigData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAgentConfigParameters>,
      OperationError<GetAgentConfigError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAgentConfigData = qraft.agentConfigsService.getAgentConfig.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAgentConfigCombinedData = qraft.agentConfigsService.getAgentConfig.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAgentConfigSchema,
          GetAgentConfigParameters,
          GetAgentConfigData,
          GetAgentConfigError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAgentConfigData, GetAgentConfigError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAgentConfigData, GetAgentConfigError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        GetAgentConfigError
      >
    ): Promise<GetAgentConfigData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        GetAgentConfigError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        GetAgentConfigError
      >
    ): Promise<GetAgentConfigData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetAgentConfigParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        DeepReadonly<TPageParam>,
        GetAgentConfigError
      >
    ): Promise<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetAgentConfigParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        DeepReadonly<TPageParam>,
        GetAgentConfigError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetAgentConfigParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        DeepReadonly<TPageParam>,
        GetAgentConfigError
      >
    ): Promise<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>
    ): GetAgentConfigData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>
    ): OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
            data: NoInfer<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
            data: GetAgentConfigData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>
    ): QueryState<GetAgentConfigData, GetAgentConfigError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAgentConfigParameters>
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
    ): QueryState<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>, GetAgentConfigError> | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetAgentConfigParameters>
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
      updater: Updater<NoInfer<GetAgentConfigData> | undefined, NoInfer<DeepReadonly<GetAgentConfigData>> | undefined>,
      options?: SetDataOptions
    ): GetAgentConfigData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAgentConfigParameters>
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      updater: Updater<NoInfer<GetAgentConfigData> | undefined, NoInfer<GetAgentConfigData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAgentConfigData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAgentConfigSchema,
        GetAgentConfigData,
        TInfinite,
        GetAgentConfigParameters,
        GetAgentConfigError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): number;
    schema: GetAgentConfigSchema;
    types: {
      parameters: GetAgentConfigParameters;
      data: GetAgentConfigData;
      error: GetAgentConfigError;
    };
  };
  /** @summary Update */
  updateAgentConfig: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateAgentConfigBody, UpdateAgentConfigParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateAgentConfigSchema,
        options: ServiceOperationMutationFnOptions<UpdateAgentConfigBody, UpdateAgentConfigParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateAgentConfigData, UpdateAgentConfigError>>
    ): Promise<RequestFnResponse<UpdateAgentConfigData, UpdateAgentConfigError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateAgentConfigParameters> | void
    ): ServiceOperationMutationKey<UpdateAgentConfigSchema, UpdateAgentConfigParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.updateAgentConfig.useMutation({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.updateAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateAgentConfigBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateAgentConfigParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateAgentConfigSchema,
        UpdateAgentConfigData,
        UpdateAgentConfigParameters,
        TVariables,
        OperationError<UpdateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<UpdateAgentConfigData, OperationError<UpdateAgentConfigError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.updateAgentConfig.useMutation({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentConfigsService.updateAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateAgentConfigSchema,
        UpdateAgentConfigData,
        UpdateAgentConfigParameters,
        TVariables,
        OperationError<UpdateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<UpdateAgentConfigData, OperationError<UpdateAgentConfigError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateAgentConfigTotal = qraft.agentConfigsService.updateAgentConfig.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateAgentConfigTotal = qraft.agentConfigsService.updateAgentConfig.useIsMutating({
     *     parameters: {
     *         path: {
     *             agent_config_id: agentConfigId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAgentConfigSchema,
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateAgentConfigPendingMutationVariables = qraft.agentConfigsService.updateAgentConfig.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateAgentConfigMutationData = qraft.agentConfigsService.updateAgentConfig.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 agent_config_id: agentConfigId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateAgentConfigData,
        OperationError<UpdateAgentConfigError>,
        MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAgentConfigSchema,
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateAgentConfigData,
          OperationError<UpdateAgentConfigError>,
          MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAgentConfigSchema,
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentConfigsService.updateAgentConfig.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             agent_config_id: agentConfigId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentConfigsService.updateAgentConfig.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateAgentConfigSchema,
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
      ):
        | Mutation<
            UpdateAgentConfigData,
            UpdateAgentConfigError,
            MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateAgentConfigSchema,
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateAgentConfigData,
          UpdateAgentConfigError,
          MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
          TContext
        >
      >;
    };
    schema: UpdateAgentConfigSchema;
    types: {
      parameters: UpdateAgentConfigParameters;
      data: UpdateAgentConfigData;
      error: UpdateAgentConfigError;
      body: UpdateAgentConfigBody;
    };
  };
}
/** @summary List */
export const listAgentConfigs = {
  schema: {
    method: 'get',
    url: '/agent/configs/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListAgentConfigsSchema;
  [QraftServiceOperationsToken]: AgentConfigsService['listAgentConfigs'];
};
/** @summary Create */
export const createAgentConfig = {
  schema: {
    method: 'post',
    url: '/agent/configs/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateAgentConfigSchema;
  [QraftServiceOperationsToken]: AgentConfigsService['createAgentConfig'];
};
/** @summary Get */
export const getAgentConfig = {
  schema: {
    method: 'get',
    url: '/agent/configs/{agent_config_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAgentConfigSchema;
  [QraftServiceOperationsToken]: AgentConfigsService['getAgentConfig'];
};
/** @summary Update */
export const updateAgentConfig = {
  schema: {
    method: 'patch',
    url: '/agent/configs/{agent_config_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateAgentConfigSchema;
  [QraftServiceOperationsToken]: AgentConfigsService['updateAgentConfig'];
};
export const agentConfigsService = {
  listAgentConfigs,
  createAgentConfig,
  getAgentConfig,
  updateAgentConfig,
} as const;
type ListAgentConfigsSchema = {
  method: 'get';
  url: '/agent/configs/';
  security: ['HTTPBearer'];
};
type ListAgentConfigsParameters = undefined;
type ListAgentConfigsData = paths['/agent/configs/']['get']['responses']['200']['content']['application/json'];
type ListAgentConfigsError = unknown;
type CreateAgentConfigSchema = {
  method: 'post';
  url: '/agent/configs/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateAgentConfigParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateAgentConfigData = paths['/agent/configs/']['post']['responses']['200']['content']['application/json'];
type CreateAgentConfigError = paths['/agent/configs/']['post']['responses']['422']['content']['application/json'];
type CreateAgentConfigBody = paths['/agent/configs/']['post']['requestBody']['content']['application/json'];
type GetAgentConfigSchema = {
  method: 'get';
  url: '/agent/configs/{agent_config_id}';
  security: ['HTTPBearer'];
};
type GetAgentConfigParameters = paths['/agent/configs/{agent_config_id}']['get']['parameters'];
type GetAgentConfigData =
  paths['/agent/configs/{agent_config_id}']['get']['responses']['200']['content']['application/json'];
type GetAgentConfigError =
  paths['/agent/configs/{agent_config_id}']['get']['responses']['422']['content']['application/json'];
type UpdateAgentConfigSchema = {
  method: 'patch';
  url: '/agent/configs/{agent_config_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateAgentConfigParameters = paths['/agent/configs/{agent_config_id}']['patch']['parameters'];
type UpdateAgentConfigData =
  paths['/agent/configs/{agent_config_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateAgentConfigError =
  paths['/agent/configs/{agent_config_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateAgentConfigBody =
  paths['/agent/configs/{agent_config_id}']['patch']['requestBody']['content']['application/json'];
